var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropdown1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1454 8.75522C22.1454 11.5995 19.8397 13.9052 16.9954 13.9052C14.1512 13.9052 11.8454 11.5995 11.8454 8.75522C11.8454 5.91096 14.1512 3.60522 16.9954 3.60522C19.8397 3.60522 22.1454 5.91096 22.1454 8.75522Z",
    fill: "#52B9F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2356 19.4517C25.2356 22.0928 21.5464 23.1492 16.9956 23.1492C12.4448 23.1492 8.75561 22.0928 8.75561 19.4517C8.75561 17.0785 12.4448 15.7543 16.9956 15.7543C21.5464 15.7543 25.2356 16.8107 25.2356 19.4517Z",
    fill: "#52B9F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.995 10.8422C16.995 13.6865 14.6893 15.9922 11.845 15.9922C9.00077 15.9922 6.69504 13.6865 6.69504 10.8422C6.69504 7.99794 9.00077 5.69221 11.845 5.69221C14.6893 5.69221 16.995 7.99794 16.995 10.8422Z",
    fill: "url(#paint0_linear_1668_2964)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0852 21.5387C20.0852 24.1797 16.3961 25.2361 11.8452 25.2361C7.2944 25.2361 3.60522 24.1797 3.60522 21.5387C3.60522 19.1655 7.2944 17.8413 11.8452 17.8413C16.3961 17.8413 20.0852 18.8977 20.0852 21.5387Z",
    fill: "url(#paint1_linear_1668_2964)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1668_2964",
    x1: 14.4204,
    y1: 3.60522,
    x2: 14.4204,
    y2: 25.2361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B86BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D18BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1668_2964",
    x1: 14.4204,
    y1: 3.60522,
    x2: 14.4204,
    y2: 25.2361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B86BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D18BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdown1);
export default __webpack_public_path__ + "static/media/icon-dropdown1.cbeadf8306bd0ddd8806276c61ff278a.svg";
export { ForwardRef as ReactComponent };